import { BarChart3, ClipboardList, FileBarChart, FileText, Package, Users } from 'lucide-react'

import { SubTabShell, type SubTab } from '@/components/SubTabShell'

const SUBTABS: SubTab[] = [
  { path: '/main/delivery',              label: '전표별',   Icon: FileText,     matchExact: true, hint: '출고전표 입력·수정' },
  { path: '/main/delivery/by-partner',   label: '거래처별', Icon: Users,        hint: '거래처별 매출 합계 + 상세' },
  { path: '/main/delivery/by-item',      label: '품목별',   Icon: BarChart3,    hint: '품목별 매출 합계 + 상세' },
  { path: '/main/delivery/sales-report', label: '판매월보', Icon: FileBarChart, hint: '라인 단위 매출 평면 조회' },
  { path: '/main/delivery/purchase-register', label: '구매장', Icon: ClipboardList, hint: '하루 출고를 품목별로 뒤집은 매입 집계 (인쇄·엑셀)' },
]

export function DeliveryShell() {
  return (
    <SubTabShell
      Icon={Package}
      title="출고처리"
      subtitle="전표 입력 + 거래처별·품목별·라인 단위 조회"
      subtabs={SUBTABS}
    />
  )
}
